import { withReadyToRenderGuard } from '@utils/guards/withReadyToRenderGuard.component'
import { withMobileGuard } from '@utils/guards/withMobileGuard.component'
import { withUserGuard } from '@utils/guards/withUserGuard.component'

import { MainPage } from './main.page'
import { MobileMainPage } from './mobile.main.page'

export const GuardMainPage = withReadyToRenderGuard(withUserGuard(withMobileGuard(MainPage, MobileMainPage)))
